import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { CustomNavbar, CustomNavIcoItem } from './headerElements'
import { Container } from '@/components/styles'
import HeaderBrand from './headerBrand'
import { Nav } from 'rsuite'
import { FaCar } from 'react-icons/fa6'
import HeaderLanguage from './headerLanguage'
import { configSelectors } from '@/store/configs'
import { productSelectors } from '@/store/products'

const Header = ({
  onBrandChange = () => {},
  returnToLandingPage = () => {},
  changeLocale = () => {},
  autentincatedOptions,
  locale,
  customerId
}) => {
  const { isOnline, isInFrame, isInApp, showStaticLogo } = useSelector(configSelectors.selectConfigs)
  const { brand: brands } = useSelector(productSelectors.selectOptionsPerFilter)
  const filterBy = useSelector(productSelectors.selectFilterBy)
  const router = useRouter()
  return (
    <div style={{ display: isInFrame || isInApp ? 'none' : 'block' }}>
      <CustomNavbar appearance="subtle" id={`navbar-${customerId}`}>
        <Container>
          <HeaderBrand
            brands={brands}
            filterBy={filterBy}
            isOnline={isOnline}
            showStaticLogo={showStaticLogo}
            onBrandChange={brand => onBrandChange(brand, () => router.push('/'))}
          />
          <Nav pullRight>
            <CustomNavIcoItem id="home" onClick={e => returnToLandingPage(e, isOnline)}>
              <FaCar size={24} />
            </CustomNavIcoItem>
            {autentincatedOptions}
            <HeaderLanguage locale={locale} changeLocale={changeLocale} />
          </Nav>
        </Container>
      </CustomNavbar>
    </div>
  )
}

export default Header
